// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"063e6094","453":"33c6eb38","740":"53d56710"}[chunkId] + ".chunk.js";
};